export default "__VITE_ASSET__BGYKk7kL__"